/** Shared shell for trust/legal pages: consistent heading + prose styling. */
export const LegalPage = ({ title, subtitle, children, testId }) => (
  <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16" data-testid={testId}>
    <h1 className="text-3xl sm:text-4xl font-heading font-semibold tracking-tight">{title}</h1>
    {subtitle && <p className="text-muted-foreground mt-2">{subtitle}</p>}
    <div className="mt-8 space-y-6">{children}</div>
  </div>
);

export const LegalSection = ({ title, children }) => (
  <section>
    <h2 className="text-lg font-heading font-semibold">{title}</h2>
    <div className="mt-2 text-sm text-muted-foreground leading-relaxed space-y-2">{children}</div>
  </section>
);
